module.exports = __webpack_public_path__ + "img/workshops_2.2.2e95ffb1.jpeg";